module.exports = __webpack_public_path__ + "static/media/fondo-slide-2.8d2c7f19.jpg";